import { useEffect, useState } from 'react'
import Modal from '../../components/common/Modal'
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard'

const emptyForm = {
    Title: '',
    StartDate: '',
}

const WervingsactieModal = ({ modalOpen, setModalOpen, actie, onSave }) => {
    const [form, setForm] = useState(emptyForm)

    useEffect(() => {
        if (!modalOpen) return

        setForm(actie ? {
            Title: actie.Title || '',
            StartDate: actie.StartDate || '',
        } : emptyForm)
    }, [modalOpen, actie])

    const update = (field) => (e) => {
        const value = e.target.value
        setForm((prev) => ({ ...prev, [field]: value }))
    }

    const confirm = () => {
        if (!form.Title.trim()) return
        onSave(form)
    }

    const content = (
        <ReadOnlyGuard edit='housevisits.edit'>
            <div className='materials-modal-form'>
                <div className='materials-modal-field'>
                    <label><b>Naam</b></label>
                    <input
                        type='text'
                        value={form.Title}
                        onChange={update('Title')}
                        placeholder='bv. Deuractie Vijver en omgeving'
                        autoFocus
                    />
                </div>

                <div className='materials-modal-field'>
                    <label><b>Startdatum</b></label>
                    <input
                        type='date'
                        value={form.StartDate}
                        onChange={update('StartDate')}
                    />
                </div>
            </div>
        </ReadOnlyGuard>
    )

    return (
        <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            confirm={confirm}
            pageHeader={actie ? 'Wervingsactie bewerken' : 'Wervingsactie toevoegen'}
            content={content}
        />
    )
}

export default WervingsactieModal
